import styled from 'styled-components';
import NextLink from 'next/link';

import CustomIcon from '@components/utils/CustomIcon';

export const BreadcrumbLink = styled.span`
  cursor: pointer;
`;

export const BreadcrumbText = styled.span`
  font-weight: 600;
`;

export const Link = styled(NextLink)`
  color: ${({ theme }) => theme.palette.grey800};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: ${({ theme }) => theme.palette.primaryBrand};
  }
`;

export const Name = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.grey1100};
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const NextArrow = styled(CustomIcon)`
  margin: 0 6px;
`;

export const BreadcrumbItem = styled.span`
  display: inline-flex;

  &:last-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
